<template>
    <div class="animated fadeIn h-100 m-4">
    <CCard>
      <CCardHeader @click="innerCollapse = !innerCollapse"><strong>Filter</strong><span size="sm" class="float-right" color="info"><i :class="'fa '+ (innerCollapse ? 'fa-window-minimize' : 'fa-window-maximize')" aria-hidden="true"></i></span></CCardHeader>
      <CCollapse :show="innerCollapse" class="mt-2">
        <CCardBody>
          <CRow class="mb-2">
            <CCol sm="4">
              <label for="deviceList">Sensors: </label>
              <vue-tags-input input-id="deviceList" v-model="device" :tags="devices" @tags-changed="newDevices => devices = newDevices" placeholder="Add Sensors" :autocomplete-items="autosensors" />
            </CCol>
            <CCol sm="1">
              <label for="dateFrom">From: </label>
              <date-picker input-id="dateFrom" ref="dateFrom" v-model="dateFrom" :config="options" style="width: initial;"></date-picker>
            </CCol>
            <CCol sm="1">
              <label for="dateFrom">To: </label>
              <date-picker input-id="dateTo" v-model="dateTo" :config="options" style="width: initial;"></date-picker>
            </CCol>
            <CCol sm="1"></CCol>
            <CCol sm="5">
              <label for="frameAgg">Frame aggregation: </label>
              <vue-slider input-id="frameAgg" name="frameAgg" v-model="frameUnifyDurationSlider" v-bind="sliderOptions" :tooltip-formatter="frameFormater"/>
            </CCol>
          </CRow>
          <CRow class="mb-4">
            <CCol sm="4">
              <label for="tagsList">Tags: </label>
              <vue-tags-input input-id="tagsList" v-model="tag" :tags="tags" @tags-changed="newTags => tags = newTags" :autocomplete-items="autotags" />
            </CCol>
            <CCol sm="8">
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <CButton color="info" shape="square" class="pl-5 pr-5 mr-2" @click="btnFilter()">Filter</CButton>
              <CButton color="info" shape="square" class="pl-5 pr-5 mr-2" @click="btnExport()">Export</CButton>
              <CButton color="info" shape="square" class="pl-5 pr-5" @click="btnExportRaw()">Export RAW</CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCollapse>
    </CCard>
    <CCard>
      <CCardHeader><strong>Contractors presence tracking</strong></CCardHeader>
      <CCardBody>
          <CDataTable
              striped="striped"
              bordered="bordered"
              small="small"
              fixed="fixed"
              :items="convertedData"
              :fields="fields"
              :items-per-page="5"
              class="m-3 w-100"
              pagination
            >
            <template #details="{item}">
              <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration" class="mr-4 ml-2">
                <TimeLine v-if="item.ticks !== undefined && item.ticks.length > 0" :items="item.ticks" :beginning="startDay(item.time)" :ending="endDay(item.time)" class="mb-5"></TimeLine>
              </CCollapse>
            </template>
            <template #duration="{item}"><td>{{ secondsToHours(item.duration) }}</td></template>
            <template #durationclean="{item}"><td>{{ secondsToHours(item.durationclean) }}</td></template>
            <template #firstmove="{item}"><td>{{ (new Date(item.firstmove*1000)).toLocaleString() }}</td></template>
            <template #lastmove="{item}"><td>{{ (new Date(item.lastmove*1000)).toLocaleString() }}</td></template>
            <template #break="{item}"><td>{{ secondsToHours(item.lastmove - item.firstmove - item.durationclean) }}</td></template>
            <template #show_details="{item}"><td>
              <CButton
                color="primary"
                variant="outline"
                square
                size="sm"
                class="mt-0"
                @click="toggleDetails(item, index)"
              >
                {{ item._toggled ? 'Hide' : 'Show' }}
              </CButton></td>
            </template>
          </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import { telemetry } from '@/api'
import TimeLine from '@/components/TimeLine'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'Occupancy',
  components: {
      datePicker,
      VueSlider,
      TimeLine,
      VueTagsInput
  },
  data () {
    return {
      selectedDate: new Date(),
      occupancyData: [],
      convertedData: [],
      innerCollapse: false,
      collapseDuration: 100,
      frameUnifyDurationSlider: 10,
      frameUnifyDuration: 10,
      bDateChanged: false,
      device: '',
      devices: [],
      tag: '',
      tags: [],
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      autosensors: [],
      sliderOptions: {
        min: 0,
        max: 480,
        interval: 5,
      },
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      frameFormater: v => (this.minutesToHours(v)),
      fields: [{key: 'time', label: 'Day'}, {key: 'duration', label: 'Movement duration'}, {key: 'firstmove', label: 'From'}, {key: 'lastmove', label: 'To'}, {key: 'show_details', label: 'Details'}]
    }
  },
  computed: {
    autotags() {
      var ret = []
      for(var idx=0; idx < this.$store.state.tags.length; idx++) ret.push({text: this.$store.state.tags[idx]})
      return ret
    }
  },
  watch: {
    dateFrom: function(val) {
      this.bDateChanged = true
    },
    dateTo: function(val) {
      this.bDateChanged = true
    }
    //frameUnifyDuration: function(val) {
    //  this.filterData()
    //}
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData() {
      var filter = {}
      if(this.dateFrom !== null && this.dateFrom != '') filter.dateFrom = Math.round(Date.parse(this.dateFrom)/1000)
      if(this.dateTo !== null && this.dateTo != '') filter.dateTo = Math.round(Date.parse(this.dateTo)/1000)
      telemetry.occupancy(filter).then(response => {
        this.bDateChanged = false
        this.occupancyData = response.data
        this.filterData()
      })
    },
    minutesToHours(minutes) {
      var hours = Math.floor(minutes / 60)
      var minutes = minutes - (hours * 60)
      return (hours < 10 ? '0' : '') + hours + ":" + (minutes < 10 ? '0' : '') + minutes
    },
    btnFilter() {
      this.frameUnifyDuration = this.frameUnifyDurationSlider
      if(this.bDateChanged)  this.loadData()
      else this.filterData()
    },
    btnExport() {
      var csvContent = ''
      var header = ['date','asset','durration','start','end']
      for(var idx=0; idx<this.convertedData.length;idx++) {
        for(var idxT=0; idxT<this.convertedData[idx].ticks.length;idxT++) {
            var startTime = Infinity
            var endTime = 0
            for(var idxTT=0; idxTT<this.convertedData[idx].ticks[idxT].times.length;idxTT++) {
                startTime = Math.min(startTime, this.convertedData[idx].ticks[idxT].times[idxTT].starting_time)
                endTime = Math.max(endTime, this.convertedData[idx].ticks[idxT].times[idxTT].ending_time)
            }
            csvContent += this.convertedData[idx].time+';'+this.convertedData[idx].ticks[idxT].label+';'+(''+(this.convertedData[idx].ticks[idxT].duration/3600)).replace('.', ',')+';'+(new Date(startTime)).toLocaleTimeString()+';'+(new Date(endTime)).toLocaleTimeString()+'\r\n'
        }
      }

      csvContent =
          "data:text/csv;charset=utf-8,\ufeff" +
          header.join(";") +
          "\r\n" +
          csvContent;
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "export.csv")
      link.innerHTML = "Click Here to download"
      link.dispatchEvent(
        new MouseEvent(`click`, {
          bubbles: true,
          cancelable: true,
          view: window
        })
      )
    },
    btnExportRaw() {
      var csvContent = ''
      var header = ['date','device','name','start','end']
      for(var idx=0; idx<this.convertedData.length;idx++) {
        for(var idxT=0; idxT<this.convertedData[idx].ticks.length;idxT++) {
          for(var idxTT=0; idxTT<this.convertedData[idx].ticks[idxT].times.length;idxTT++) {
            csvContent += this.convertedData[idx].time+';'+this.convertedData[idx].ticks[idxT].device+';'+this.convertedData[idx].ticks[idxT].label+';'+(new Date(this.convertedData[idx].ticks[idxT].times[idxTT].starting_time)).toLocaleTimeString()+';'+(new Date(this.convertedData[idx].ticks[idxT].times[idxTT].ending_time)).toLocaleTimeString()+'\r\n'
          }
        }
      }

      csvContent =
          "data:text/csv;charset=utf-8,\ufeff" +
          header.join(";") +
          "\r\n" +
          csvContent;
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "export.csv")
      link.innerHTML = "Click Here to download"
      link.dispatchEvent(
        new MouseEvent(`click`, {
          bubbles: true,
          cancelable: true,
          view: window
        })
      )
    },
    previous2weeks(date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay(date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay(date) {
      date.setHours(23,59,59,999)
      return date
    },
    filterData() {
      var sensors = []
      var filterDevices = []
      var filterTags = []
      this.convertedData = []

      for(var i=0; i<this.devices.length; i++) if(!filterDevices.includes(this.devices[i].text)) filterDevices.push(this.devices[i].text)
      for(var i=0; i<this.tags.length; i++) if(!filterTags.includes(this.tags[i].text)) filterTags.push(this.tags[i].text)

      for(var idx=0; idx<this.occupancyData.length;idx++) {
        var day = {"time": this.occupancyData[idx].time, "ticks": [], firstmove: Infinity, lastmove: -Infinity, duration: 0, durationclean: 0, _toggled: true}
        for(var idxDev=0; idxDev<this.occupancyData[idx].ticks.length;idxDev++) {
          if(!sensors.includes(this.occupancyData[idx].ticks[idxDev].label)) sensors.push(this.occupancyData[idx].ticks[idxDev].label)

          if((filterDevices.length == 0 || filterDevices.includes(this.occupancyData[idx].ticks[idxDev].label)) && (filterTags.length == 0 || filterTags.some(r=> this.occupancyData[idx].ticks[idxDev].tags !== null && this.occupancyData[idx].ticks[idxDev].tags.includes(r)))) {
            var device = {device: this.occupancyData[idx].ticks[idxDev].device, label: this.occupancyData[idx].ticks[idxDev].label,times: [], duration: 0}

            var frameStart = 0
            var frameEnd = 0

            for(var idxTime=this.occupancyData[idx].ticks[idxDev].times.length-1; idxTime >= 0; idxTime--) {
              if(frameStart == 0) {
                frameStart = this.occupancyData[idx].ticks[idxDev].times[idxTime].starting_time
                frameEnd = this.occupancyData[idx].ticks[idxDev].times[idxTime].ending_time
              }

              if(this.occupancyData[idx].ticks[idxDev].times[idxTime].ending_time - frameEnd > (this.frameUnifyDuration * 60000) || idxTime == 0) {
                day.firstmove = Math.min(day.firstmove, frameStart)
                day.lastmove = Math.max(day.lastmove, this.occupancyData[idx].ticks[idxDev].times[idxTime].ending_time)
                day.duration += (frameEnd - frameStart) / 1000
                device.duration  += (frameEnd - frameStart) / 1000
                device.times.push({starting_time: frameStart, ending_time: frameEnd})
                frameStart = this.occupancyData[idx].ticks[idxDev].times[idxTime].starting_time
                frameEnd = this.occupancyData[idx].ticks[idxDev].times[idxTime].ending_time
              } else {
                frameEnd = this.occupancyData[idx].ticks[idxDev].times[idxTime].ending_time
              }

            }
            day.ticks.push(device)
          }
        }
        day.durationclean = day.duration
        if(day.firstmove == Infinity) {
          delete day.firstmove
        } else {
          day.firstmove /= 1000
        }
        if(day.lastmove == -Infinity) {
          delete day.lastmove
        } else {
          day.lastmove /= 1000
        }
        if(day.firstmove !== undefined) this.convertedData.push(day)
      }
      this.autosensors = []
      for(var idx=0; idx < sensors.length; idx++) this.autosensors.push({text: sensors[idx]})
    },
    secondsToHours(sec) {
      var hours = Math.floor(sec / 3600)
      var minutes = Math.floor((sec - (hours * 3600)) / 60)
      var seconds = Math.floor(sec - (hours * 3600) - (minutes * 60))
      return (hours < 10 ? '0' : '') + hours + ":" + (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds
    },
    toggleDetails(item, index) {
      item._toggled = item._toggled == true ? false : true
    },
    startDay(day) {
      return (new Date(day)).getTime() + (60000 * (new Date()).getTimezoneOffset())
    },
    endDay(day) {
      return this.startDay(day) + (24*60*60*1000)
    }
  }
}
</script>
